import { z } from 'zod'

import { FundingAmount } from '../../../cross-chain-deployment/FundingAmount'

export const FundingAmountSchema = z.number()

type FundingAmountReportText = z.infer<typeof FundingAmountSchema>

export function mapDomainToReportText(
  fundingAmount: FundingAmount
): FundingAmountReportText {
  return fundingAmount.toNumber()
}

export function mapReportTextToDomain(
  reportText: FundingAmountReportText
): FundingAmount {
  return FundingAmount.create({
    fundingAmountValue: reportText,
  })
}
